import script from "./TermInUse.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermInUse.vue?vue&type=script&setup=true&lang=ts"

import "./TermInUse.vue?vue&type=style&index=0&id=660d023e&lang=scss"

const __exports__ = script;

export default __exports__